import moment from 'moment'
import { EhrAppointmentReason, EhrAppointmentStateKind } from '@src/types'
import { EhrAppointmentCustomType } from '../../utils'

const appointmentCancelledDuringCoachSwitch = (appointment: EhrAppointmentCustomType) => {
  return (
    appointment.lastState.kind === EhrAppointmentStateKind.Cancelled &&
    appointment.lastState.reason === EhrAppointmentReason.CoachSwitch
  )
}

export const getLatestCoachSwitchCancelledAppointment = (
  appointments: EhrAppointmentCustomType[] | null,
) => {
  const sortedByUpdatedAt = appointments?.sort(
    (a, b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf(),
  )

  if (!sortedByUpdatedAt || sortedByUpdatedAt.length === 0) {
    return null
  }

  let mostRecentCoachSwitchAppointment = sortedByUpdatedAt[0]

  if (appointmentCancelledDuringCoachSwitch(mostRecentCoachSwitchAppointment)) {
    for (const appointment of sortedByUpdatedAt.slice(1)) {
      if (
        appointmentCancelledDuringCoachSwitch(appointment) &&
        moment(appointment.meetingAt).isBefore(moment(mostRecentCoachSwitchAppointment.meetingAt))
      ) {
        mostRecentCoachSwitchAppointment = appointment
      } else {
        return mostRecentCoachSwitchAppointment
      }
    }

    return mostRecentCoachSwitchAppointment
  }

  return null
}
